import { render, staticRenderFns } from "./SoftwarePartnerList.vue?vue&type=template&id=80187df0"
import script from "./SoftwarePartnerList.vue?vue&type=script&lang=js"
export * from "./SoftwarePartnerList.vue?vue&type=script&lang=js"
import style0 from "./SoftwarePartnerList.vue?vue&type=style&index=0&id=80187df0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports